import React from 'react'
import { Link, useParams } from 'react-router-dom'

import {
  carModelDisplayLabel,
  carsPath,
  carSubModelDisplayLabel,
  getMaskedString,
  makeSearchPath,
} from '@/utils'
import { CarNode } from '@/apollo/graphql'
import { useApp } from '@/hooks'

interface ICarRow {
  node: CarNode
}

const CarRow: React.FC<ICarRow> = ({ node }) => {
  const { isRTL } = useApp()
  const { customerId } = useParams()

  return (
    <Link
      to={makeSearchPath(carsPath, {
        customerId,
        id: node.id,
      })}
    >
      <li>
        <div className="data">
          <h4>{carModelDisplayLabel(node, isRTL)}</h4>
          <p>{carSubModelDisplayLabel(node, isRTL)}</p>
          <p>{getMaskedString(node.number, true)}</p>
        </div>
      </li>
    </Link>
  )
}

export default CarRow
